import Css from "./style.module.scss";

import { TagsInput } from "nlib/ui";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import React from "react";

const ExcludedWords = ({ value, disabled, onChange, ...restProps }) => {
  const { messages } = useSelector(getTextsData);

  return (
    <div className={Css.excludedWords}>
      <TagsInput
        value={value}
        disabled={disabled}
        className={Css.input}
        onChange={onChange}
        placeholder={messages.rpaExcludedWordsPlaceholder}
        invalid={!value?.length}
        {...restProps} />
    </div>
  );
};

export default React.memo(ExcludedWords);
